"use strict";

var _classCallCheck = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeSet = exports.binarySearch = void 0;

var _compare = require("./compare");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var binarySearch = function binarySearch(comparator, elements, target) {
  var left = 0;
  var right = elements.length - 1;

  while (left <= right) {
    var middle = left + right >> 1;
    var cmp = comparator(elements[middle], target);

    if (cmp < 0) {
      left = middle + 1;
    } else if (cmp > 0) {
      right = middle - 1;
    } else {
      return middle;
    }
  }

  return left;
};

exports.binarySearch = binarySearch;

var TreeSet =
/*#__PURE__*/
function () {
  function TreeSet() {
    var comparator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _compare.compareNature)();
    var elements = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, TreeSet);

    _defineProperty(this, "elements", []);

    _defineProperty(this, "comparator", void 0);

    this.comparator = comparator;
    elements && this.pushAll(elements);
  }

  _createClass(TreeSet, [{
    key: "top",

    /**
     * get and remove the head element
     */
    value: function top() {
      if (this.isEmpty) return undefined;
      return this.elements.splice(0, 1)[0];
    }
    /**
     * get and remove the last element
     */

  }, {
    key: "pop",
    value: function pop() {
      if (this.isEmpty) return undefined;
      return this.elements.splice(this.size - 1, 1)[0];
    }
  }, {
    key: "push",
    value: function push(element) {
      var index = binarySearch(this.comparator, this.elements, element);
      this.elements.splice(index, 0, element);
    }
  }, {
    key: "pushAll",
    value: function pushAll(elements) {
      var _this = this;

      elements.forEach(function (element) {
        return _this.push(element);
      });
    }
  }, {
    key: "size",
    get: function get() {
      return this.elements.length;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.elements.length === 0;
    }
  }, {
    key: "head",
    get: function get() {
      return this.elements[0];
    }
  }, {
    key: "last",
    get: function get() {
      return this.elements[this.size - 1];
    }
  }]);

  return TreeSet;
}();

exports.TreeSet = TreeSet;